import Future from 'fluture';
import cookies from 'browser-cookies';
import * as r from 'ramda';

export default function createCleanse(

) {
  return function cleanse(
    preserve,
  ) {
    const items = cookies.all();

    const toCleanse = r.pipe(
      r.keys,
      r.reject(r.contains(r.__, preserve)),
    )(items);

    r.forEach((key) => {
      cookies.erase(key, {
        domain: window.utag.cfg.domain,
      });
    })(toCleanse);

    return Future.of(true);
  }
}



// WEBPACK FOOTER //
// ./src/infrastructure/cleanse.js